import React, { useEffect } from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Divider, Modal, Table } from "antd";
import toast from "react-hot-toast";
import { ErrorToast, SuccessToast, UpdatedToast } from "../../../views/ToastComponent";

const CableOperator = ({ profileId, ProfileId }) => {
  const [allBusinessPd, setAllBusinessPd] = React.useState([]);
  const [areaType, setAreaType] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [EditDataId, setEditDataId] = React.useState(0);

  const [garageAutoData, setGarageAutoData] = React.useState({
    name: "", numConnection: 0, businessPdProfileId: profileId, latitude: "", longitude: "", chargePerConnection: 0, monthlyRevenue: 0, transmitterCost: 0, transitterLife: 0, deptMonth: 0, deptYear: 0, profitMarginId: 0
  });


  const [garageEditAutoData, setGarageEditAutoData] = React.useState({
    name: "", totalConnection: 0, businessPdProfileId: profileId, Latitude: "", Longitude: "", charges: 0, monthlyRevenue: 0, transmitorCost: 0, transmitorLife: 0, DepreciationMonthly: 0, DepreciationYearly: 0, ProfitMarginId: 0, Revnue: 0

  });


  //update Method

  const handleUpdate = async (id) => {
    try {
      const response = await axios.post(`${Api_Url}api/v1/CableOperatorPd/${id}`, garageEditAutoData, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        }
      })
      if (response.data.succeeded) {
        UpdatedToast("Updated successfully")
        handleCancel()
        fetchIncomeData()
      }
    } catch (error) {
      ErrorToast("something went wrong")
      return error
    }
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Total Connection",
      dataIndex: "totalConnection",
      // sorter: (a, b) => a.totalConnection.length - b.totalConnection.length,
    },
    {
      title: "Connection Charge",
      dataIndex: "charges",
      // sorter: (a, b) => a.charges.length - b.charges.length,
    },
    {
      title: "Transmitter Life",
      dataIndex: "transmitorLife",
      // sorter: (a, b) => a.transmitorLife.length - b.transmitorLife.length,
    },
    {
      title: "Transmitter Cost",
      dataIndex: "transmitorCost",
      // sorter: (a, b) => a.transmitorCost.length - b.transmitorCost.length,
    },
    {
      title: "Monthly Depreciation",
      dataIndex: "depreciationMonthly",
      // sorter: (a, b) => a.depreciationMonthly.length - b.depreciationMonthly.length,
    },
    {
      title: "Yearly Depreciation",
      dataIndex: "depreciationYearly",
      // sorter: (a, b) => a.depreciationYearly.length - b.depreciationYearly.length,
    },
    {
      title: "Revenue",
      dataIndex: "revnue",
      // sorter: (a, b) => a.revnue.length - b.revnue.length,
    },
    {
      title: "Created At",
      dataIndex: "created",
      render: (text) => {
        return new Date(text).toLocaleDateString() + "   " + new Date(text).toLocaleTimeString();
      },
      // sorter: (a, b) => a.created.length - b.created.length,
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            // className="btn btn-secondary"
            type="primary"
            onClick={() => handleClick(record.id)}
            // onClick={() => handleEdit(record.key)}
            style={{ marginLeft: '10px' }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
    // {
    //   title: 'Delete',
    //   dataIndex: 'delete',
    //   // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
    //   render: (text, record) => (
    //     <div>
    //       {text}
    //       <Button
    //         className='btn btn-danger'
    //         type="primary"
    //         // onClick={() => handleClick(record.id)}
    //         style={{ marginLeft: '10px' }}
    //       >
    //         <i class="fa-solid fa-trash"></i>
    //       </Button>
    //     </div>
    //   ),
    // },
  ];

  const fetchIncomeData = async () => {
    const { data } = await axios.get(Api_Url + "api/v1/CableOperatorPd/getbybusinesspdprofileid/" + profileId, {
      headers: {
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
      }
    });
    setAllBusinessPd(data.data)
  };

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(Api_Url + "api/v1/ProfitMargin/getbyprofileid/" + ProfileId, {
        headers: {
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
        }
      })
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGarageAutoData(prev => ({ ...prev, latitude: latitude.toString(), longitude: longitude.toString() }))
      });
    } else {
      return "Geolocation is not supported by this browser."
    }
  };
  const handleSubmit = async (operationType) => {
    try {
      const formData = new FormData();

      formData.append("BusinessPdProfileId", garageAutoData.businessPdProfileId)
      formData.append("ProfitMarginId", garageAutoData.profitMarginId)
      formData.append("Name", garageAutoData.name)
      formData.append("TotalConnection", garageAutoData.numConnection)
      formData.append("Charges", garageAutoData.chargePerConnection)
      formData.append("Revnue", garageAutoData.monthlyRevenue)
      formData.append("TransmitorCost", garageAutoData.transmitterCost)
      formData.append("TransmitorLife", garageAutoData.transitterLife)
      formData.append("DepreciationYearly", garageAutoData.deptYear)
      formData.append("DepreciationMonthly", garageAutoData.deptMonth)
      formData.append("Latitude", garageAutoData.latitude)
      formData.append("Longitude", garageAutoData.longitude)

      let response;
      if (operationType == "Submit") {
        response = await axios.post(Api_Url + "api/v1/CableOperatorPd", formData, {
          headers: {
            Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
          }
        });
        if (response.data.succeeded) {
          SuccessToast("Successfully updated")
          handleCancel()
          fetchIncomeData();
        }

      } else {
        formData.append("Id", EditDataId)
        response = await axios.post(Api_Url + "api/v1/CableOperatorPd/" + EditDataId, formData, {
          headers: {
            Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
          }
        });
        if (response.data.succeeded) {
          SuccessToast("Successfully updated")
          handleCancel()
          fetchIncomeData();
        }
      }

    } catch (error) {
      ErrorToast("Something went wrong")
      console.log(error);
    }
  };

  const calculateMonthlyRevenue = () => {
    const result = garageAutoData.numConnection * garageAutoData.chargePerConnection || 0;
    setGarageAutoData(prev => ({
      ...prev,
      monthlyRevenue: result
    }))
  };

  const calculatePerMonth = () => {
    const result = garageAutoData.transmitterCost / garageAutoData.transitterLife || 0;
    setGarageAutoData(prev => ({
      ...prev,
      deptYear: result,
      deptMonth: result / 12
    }))
  };

  React.useEffect(() => { fetchIncomeData(); fetchAreaType(); fetchCurentLocation(); }, []);

  React.useEffect(() => {
    calculateMonthlyRevenue();
  }, [garageAutoData.numConnection, garageAutoData.chargePerConnection]);

  React.useEffect(() => {
    calculatePerMonth();
  }, [garageAutoData.transmitterCost, garageAutoData.transitterLife]);

  async function handleCancel() {
    setGarageAutoData({
      ...garageAutoData,
      name: "",
      numConnection: 0,
      chargePerConnection: 0,
      monthlyRevenue: 0,
      transmitterCost: 0,
      transitterLife: 0,
      deptMonth: 0,
      deptYear: 0,
      profitMarginId: 0,
    })
    setEditDataId(0)
    setIsModalOpen(false);
  }


  const handleClick = async (id) => {

    setEditDataId(id)
    setIsModalOpen(true)

  }

  async function LoadSingleCableOperator(hereId) {
    try {
      const response = await axios.get(`${Api_Url}api/v1/CableOperatorPd/${hereId}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        }
      })
      setGarageAutoData({
        ...garageAutoData,
        name: response.data.data.name,
        numConnection: response.data.data.totalConnection,
        // businessPdProfileId: profileId,
        chargePerConnection: response.data.data.charges,
        monthlyRevenue: response.data.data.revnue,
        transmitterCost: response.data.data.transmitorCost,
        transitterLife: response.data.data.transmitorLife,
        deptMonth: response.data.data.depreciationMonthly,
        deptYear: response.data.data.depreciationYearly,
        profitMarginId: response.data.data.profitMarginId,
      })
    } catch (e) {
      console.log("Load Single Auto Driver", e.message)
    }
  }

  useEffect(() => {
    if (EditDataId !== 0) {

      LoadSingleCableOperator(EditDataId)
    }
  }, [EditDataId !== 0])

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <h3 className="mb-0">Cable Operator</h3>
          <button className="btn btn-primary submit-btn" onClick={() => setIsModalOpen(true)}>Add Operator</button>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      <Modal
        title={<h4>{EditDataId == 0 ? "Add" : "Edit"} Cable Operator</h4>}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        // closable={false}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
            <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}>{EditDataId == 0 ? "Submit" : "Update"}</button>
          </div>
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <Divider>Operator Information</Divider>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select id="vehicleType" className="custom-select-style" value={garageAutoData.profitMarginId} onChange={event => setGarageAutoData(prev => ({ ...prev, profitMarginId: event.target.value }))}>
                    <option value={0} selected>Select Vehicle Type</option>
                    {areaType.length > 0 && areaType.map(area => <option value={area.id}>{area.name}</option>)}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Cable Operator Name
                  </label>
                  <input className="form-control" type="text" placeholder="Cable Operator Name" value={garageAutoData.name} onChange={event => setGarageAutoData(prev => ({ ...prev, name: event.target.value }))} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Number of Connection
                  </label>
                  <input className="form-control" type="number" placeholder="Number of Connection" value={garageAutoData.numConnection} onChange={event => setGarageAutoData(prev => ({ ...prev, numConnection: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Per Connection Charge
                  </label>
                  <input className="form-control" type="number" placeholder="Per Connection Charge" value={garageAutoData.chargePerConnection} onChange={event => setGarageAutoData(prev => ({ ...prev, chargePerConnection: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Monthly Revenue: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageAutoData.monthlyRevenue.toFixed(2)}</span>
              </div>
            </div>

            <Divider>Required Information</Divider>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Transmitter Cost
                  </label>
                  <input className="form-control" type="number" placeholder="Transmitter Cost" value={garageAutoData.transmitterCost} onChange={event => setGarageAutoData(prev => ({ ...prev, transmitterCost: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Transmitter Life (Year)
                  </label>
                  <input className="form-control" type="number" placeholder="Transmitter Life (Year)" value={garageAutoData.transitterLife} onChange={event => setGarageAutoData(prev => ({ ...prev, transitterLife: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Dept per Month: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageAutoData.deptMonth.toFixed(2)}</span>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Dept per Year: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageAutoData.deptYear.toFixed(2)}</span>
              </div>
            </div>

          </form>
        </div>
      </Modal>

      {/* Edit Modal */}

      <Modal
        title={<h4>Edit Cable Operator</h4>}
        open={isEditModalOpen}
        onOk={() => setIsEditModalOpen(false)}
        // closable={false}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
            <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}>{EditDataId == 0 ? "Submit" : "Update"}</button>
          </div>
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <Divider>Operator Information</Divider>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select id="vehicleType" className="custom-select-style" value={garageEditAutoData.ProfitMarginId} onChange={event => setGarageEditAutoData(prev => ({ ...prev, ProfitMarginId: event.target.value }))}>
                    <option value={0} selected>Select Vehicle Type</option>
                    {areaType.length > 0 && areaType.map(area => <option value={area.id}>{area.name}</option>)}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Cable Operator Name
                  </label>
                  <input className="form-control" type="text" placeholder="Cable Operator Name" value={garageEditAutoData.name} onChange={event => setGarageEditAutoData(prev => ({ ...prev, name: event.target.value }))} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Number of Connection
                  </label>
                  <input className="form-control" type="number" placeholder="Number of Connection" value={garageEditAutoData.totalConnection} onChange={event => setGarageEditAutoData(prev => ({ ...prev, totalConnection: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Per Connection Charge
                  </label>
                  <input className="form-control" type="number" placeholder="Per Connection Charge" value={garageEditAutoData.charges} onChange={event => setGarageEditAutoData(prev => ({ ...prev, charges: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Monthly Revenue: </p>
                {/* <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageEditAutoData.Revnue.toFixed(2)}</span> */}
              </div>
            </div>

            <Divider>Required Information</Divider>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Transmitter Cost
                  </label>
                  <input className="form-control" type="number" placeholder="Transmitter Cost" value={garageEditAutoData.transmitorCost} onChange={event => setGarageEditAutoData(prev => ({ ...prev, transmitorCost: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Transmitter Life (Year)
                  </label>
                  <input className="form-control" type="number" placeholder="Transmitter Life (Year)" value={garageEditAutoData.transmitorLife} onChange={event => setGarageEditAutoData(prev => ({ ...prev, transmitorLife: event.target.value }))} />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Dept per Month: </p>
                {/* <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageEditAutoData.DepreciationMonthly.toFixed(2)}</span> */}
              </div>
            </div>
            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Dept per Year: </p>
                {/* <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageEditAutoData.DepreciationYearly.toFixed(2)}</span> */}
              </div>
            </div>

          </form>
        </div>
      </Modal>
    </div>
  )
}

export default CableOperator